import { TransformersEnum } from "definitions/exporter";

import { ExportTaskFormValues } from "../../ExportTasksForm.types";
import { LEGACY_ROUNDING_OPTION } from "./RoundingOptionForm.constants";

// Старый трансформер ROUNDING_PRICE заменён полем roundingOption. Чистая
// идемпотентная миграция загруженной задачи: применяется ДО reset() и ДО
// снапшота defaultStateOptions — иначе форма и дефолт разъехались бы по
// transformers/roundingOption и задача открывалась бы «грязной». На бэке
// roundingOption приоритетнее ROUNDING_PRICE, поэтому оставшийся трансформер —
// мёртвый груз, и его удаление поведения не меняет.
export function migrateRounding(
  values: ExportTaskFormValues,
): ExportTaskFormValues {
  const transformers = values.transformers ?? [];
  if (!transformers.includes(TransformersEnum.RoundingPrice)) return values;

  return {
    ...values,
    transformers: transformers.filter(
      (t) => t !== TransformersEnum.RoundingPrice,
    ),
    // Явный roundingOption (например, у уже мигрированной задачи) приоритетнее
    // легаси-пресета — не перетираем реальную настройку.
    roundingOption: values.roundingOption ?? LEGACY_ROUNDING_OPTION,
  };
}
